import { AppId } from '@inno-tools/container-bridge'

import { WidgetConfiguration } from '../getWidgets/getWidgets.types'

interface SuccessResponse<T> {
  success: boolean
  data: T
}

interface Wallpaper {
  id: string
  url: string
  created_at: string
}

export interface WallpaperAnimationResponse {
  revision: string
  asset_base_url: string
  definition?: unknown
  preview?: unknown
}

export interface PredefinedWallpaper {
  kind?: 'static' | 'animated'
  animation?: WallpaperAnimationResponse
  wallpaper_id: string
  name: string
  url: string
  thumbnail_url?: string
}

interface ActiveWallpaper {
  type: 'predefined' | 'custom'
  id: string
  url: string
}

export interface DesktopWidget {
  id: string
  widget_key: string
  configuration: WidgetConfiguration
  size: string
  display_order: number
  is_collapsed: boolean
  is_forced?: boolean
}

export interface GetAllDesktopSettingsData {
  widgets: DesktopWidget[]
  wallpapers: Wallpaper[]
  predefined_wallpapers: PredefinedWallpaper[]
  active_wallpaper: ActiveWallpaper
  pinned_apps: AppId[]
  widget_bar_location: 'left' | 'right'
}

export type GetAllDesktopSettingsResponse =
  SuccessResponse<GetAllDesktopSettingsData>
